import { SVGProps } from 'react';

export default function CollectionIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      <path
        d="M15.6475 12.3535H0.820312V25.5332H15.6475M15.6475 12.3535V25.5332M15.6475 12.3535V2.46875H5.7627V12.3535H15.6475ZM15.6475 25.5332H27.1797V15.6484H15.6475M15.6475 25.5332V15.6484M15.6475 15.6484H25.5322V5.76367H15.6475V15.6484ZM9.05762 5.76367H12.3525M5.7627 15.6484H10.7051M18.9424 9.05859H22.2373M19.585 18.9434H23.2422"
        stroke="black"
        strokeWidth="1.64062"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
